import { GET_ALL_NOTIFICATIONS } from "./notifications-query";
import { NotificationList } from "./notifications-interface";
import { notificationActions } from "../../state/notifications";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useQuery } from "@apollo/client";

const useNotificationsList = () =>{
  const dispatch = useDispatch();
  const { data, error, loading } = useQuery<{getAllNotifications: NotificationList}>(GET_ALL_NOTIFICATIONS,
    {
      fetchPolicy: "cache-and-network",
    });

  useEffect(() => {
    if (data?.getAllNotifications) {
      dispatch(notificationActions.setNotificationList(data.getAllNotifications));
    }
  }, [data]);

  return {
    notifications: data?.getAllNotifications,
    error,
    loading,
  };
};

export default useNotificationsList;
